import GenesysScheduledVideoChannel from './genesys-scheduled-video'
import FacebookMessengerChannel from './facebookMessengerChannel'
import GenesysWebMessengerChannel from './genesys-web-messenger'
import GenesysCallbackChannel from './genesys-callback'
import GenesysAudioChannel from './genesys-audio'
import GenesysVideoChannel from './genesys-video'
import GenesysFaqChannel from './genesys-faq'
import WhatsAppChannel from './whatsapp'
import CustomChannel from './custom'

export function channelFactory(settings, dependencies = {}) {
  switch (settings.type) {
    case 'genesysWebMessenger':
      return new GenesysWebMessengerChannel(settings, dependencies)
    case 'genesysCallback':
      return new GenesysCallbackChannel(settings, dependencies)
    case 'genesysCallMeScheduled':
      return new GenesysCallbackChannel(settings, dependencies)
    case 'genesysAudio':
      return new GenesysAudioChannel(settings, dependencies)
    case 'custom':
      return new CustomChannel(settings, dependencies)
    case 'genesysWhatsapp':
      return new WhatsAppChannel(settings, dependencies)
    case 'genesysFacebookMessenger':
      return new FacebookMessengerChannel(settings, dependencies)
    case 'genesysVideo':
      return new GenesysVideoChannel(settings, dependencies)
    case 'genesysFaq':
      return new GenesysFaqChannel(settings, dependencies)
    case 'genesysScheduledVideo':
      return new GenesysScheduledVideoChannel(settings, dependencies)
    default:
      return null
  }
}
